import dayjs from "dayjs";
import {
  Avatar,
  Card,
  Col,
  Flex,
  Row,
  Space,
  Typography
} from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import classes from "./appointment.module.css";
import { AppointmentType } from "../../types/user";
import useCurrentUser from "../../hooks/useCurrentUser";
import AppointmentModal from "./appointmentModal";
import AppointmentButton from "./appointmentButton";

const { Text } = Typography;

const Appointment = (props: { appointment: AppointmentType, vertical?: boolean }) => {
  const { t } = useTranslation();
  const { appointment, vertical = false } = props;
  const { isDoctor } = useCurrentUser();
  const [isEditActive, setIsEditActive] = useState(false);

  const isMeetingStarted = () => {
    return dayjs(appointment.start_at).diff(dayjs(), "minute") < 5;
  };

  return (
    isDoctor ? (
      <Card size="small" className={isMeetingStarted() ? classes.active : ""}>
        <Row gutter={[16, 16]} align="middle">
          <Col span={24} lg={vertical ? 24 : 9}>
            <Space direction="vertical" size={0} style={{ width: "100%" }}>
              <Text strong ellipsis className={classes.name}>
                {appointment.patient?.name} {appointment.patient?.surname}
              </Text>
              <Text type="secondary" className={classes.time}>
                {dayjs(appointment.start_at).format("dddd D MMMM YYYY")}
              </Text>
              <Text type="secondary" className={classes.time}>
                {dayjs(appointment.start_at).format("HH:mm")}
              </Text>
            </Space>
          </Col>
          <Col span={24} lg={vertical ? 24 : 15}>
            <AppointmentButton appointment={appointment} />
          </Col>
        </Row>
      </Card>
    ) : (
      <Card
        size="small"
        className={isMeetingStarted() ? classes.doctorActive : ""}
        style={{ height: "100%" }}
      >
        <Flex gap={16}>
          <Avatar
            size={64}
            src={(
              <img
                src={
                appointment.oncologist && appointment.oncologist.photo?.length > 0
                  ? appointment.oncologist.photo
                  : "/placeholder.png"
              }
                alt="avatar"
              />
          )}
          />
          <Flex justify="space-between" style={{ flexGrow: 1 }}>
            <Space direction="vertical" size={0}>
              <Text strong style={{ fontSize: 16 }}>
                {appointment.nutrizionist?.name ? `${t("global.labels.doctorPrefix")} ${appointment.nutrizionist.name} ${appointment.nutrizionist.surname}` : null}
                {appointment.oncologist?.name ? `${t("global.labels.doctorPrefix")} ${appointment.oncologist.name} ${appointment.oncologist.surname}` : null}
              </Text>
              {appointment.nutrizionist?.policy_number
                ? <span>n. polizza {appointment.nutrizionist.policy_number}</span> : null}
              {appointment.oncologist?.policy_number
                ? <span>n. polizza  {appointment.oncologist.policy_number}</span> : null}
              <Text type="secondary">
                {appointment.nutrizionist ? t("global.labels.nutritionist") : null}
                {appointment.oncologist?.name ? t("global.labels.oncologist") : null}
              </Text>
            </Space>
            <Space direction="vertical" size={0} style={{ textAlign: "right" }}>
              <Text strong type="secondary">
                {dayjs(appointment.start_at).format("dddd")}
              </Text>
              <Text strong style={{ color: "#356AB3" }}>
                {dayjs(appointment.start_at).format("DD/M/YYYY HH:mm")}
              </Text>
            </Space>
          </Flex>
        </Flex>
        <div style={{ marginTop: 14 }}>
          <AppointmentButton appointment={appointment} onClick={() => setIsEditActive(true)} />
        </div>
        <AppointmentModal
          appointmentId={+appointment.id}
          isOpen={isEditActive}
          onClose={() => setIsEditActive(false)}
        />
      </Card>
    )
  );
};

export default Appointment;
